import type { BooleanObject } from '@/types/public'
export const imageTypeList = ['png', 'bmp', 'jpg', 'jpeg', 'webp', 'tif', 'svg', 'gif']
export const imageTypeListMap = imageTypeList.reduce((result, key) => {
  result[key] = true
  return result
}, {} as BooleanObject)
export const videoTypeList = ['mp4', 'mov', 'avi', 'mkv', 'flv', 'webm']
export const videoTypeListMap = videoTypeList.reduce((result, key) => {
  result[key] = true
  return result
}, {} as BooleanObject)
